module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "owl-carousel slider-navigation"
  }, _vm._l((_vm.items), function(item) {
    return _c('div', {
      staticClass: "item"
    }, [_c('div', {
      staticClass: "containerItem"
    }, [_c('div', {
      staticClass: "top"
    }, [_c('span', {
      staticClass: "image",
      attrs: {
        "lazy-background": item.img
      }
    }), _c('div', {
      staticClass: "header"
    }, [_vm._v(_vm._s(item.header))])]), _vm._v(" "), _c('div', {
      staticClass: "bottom"
    }, [_c('div', {
      staticClass: "text"
    }, [_vm._v("\n\t\t\t\t\t" + _vm._s(item.text) + "\n\t\t\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "more"
    }, [_c('a', {
      staticClass: "button waves-effect waves-light",
      attrs: {
        "href": item.href
      }
    }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(item.button) + "\n\t\t\t\t\t")]), _vm._v(" "), (item.price) ? _c('span', {
      staticClass: "price",
      domProps: {
        "innerHTML": _vm._s(item.price)
      }
    }) : _vm._e()])])])])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-822ffde2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/includes/components/sliders/catalogVueslider.vue
// module id = 284
// module chunks = 38